import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { breakpoints } from "../../../theme"

const Wrapper = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 2px solid #fff;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0px 15px 25px rgba(33, 42, 88, 0.26);
  margin-bottom: 18px;

  @media (min-width: ${breakpoints.small}px) {
    width: 160px;
    height: 160px;
  }

  .gatsby-image-wrapper {
    isolation: isolate;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    object-fit: cover;
    border-radius: 50%;
    overflow: hidden;
  }
`

const Portrait = ({ image }) => {
  return <Wrapper className="portrait">{image}</Wrapper>
}

Portrait.propTypes = {
  image: PropTypes.element,
}

export { Portrait }
